import React from 'react';
import Link from 'next/link';
import AppLogo from '@/components/ui/AppLogo';

export default function Footer() {
  return (
    <footer className="bg-foreground text-primary-foreground mt-auto">
      <div className="max-w-screen-2xl mx-auto px-4 lg:px-8 xl:px-10 2xl:px-16 py-12">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
          <div className="md:col-span-1">
            <div className="flex items-center gap-2 mb-4">
              <AppLogo size={32} />
              <span className="font-bold text-lg text-white">bitvoyago.com</span>
            </div>
            <p className="text-sm text-slate-400 leading-relaxed">
              Search and book flights to anywhere in the world. Pay with crypto and save 10%. No account needed, no hidden fees.
            </p>
            <div className="mt-4 flex items-center gap-2">
              <span className="text-xs text-amber-400 font-semibold flex items-center gap-1.5">
                <svg className="w-3.5 h-3.5" viewBox="0 0 24 24" fill="currentColor">
                  <path d="M11.944 17.97L4.58 13.62 11.943 24l7.37-10.38-7.372 4.35h.003zM12.056 0L4.69 12.223l7.365 4.354 7.365-4.35L12.056 0z"/>
                </svg>
                BTC
              </span>
              <span className="text-xs text-purple-400 font-semibold flex items-center gap-1.5">
                <svg className="w-3.5 h-3.5" viewBox="0 0 24 24" fill="currentColor">
                  <path d="M11.944 17.97L4.58 13.62 11.943 24l7.37-10.38-7.372 4.35h.003zM12.056 0L4.69 12.223l7.365 4.354 7.365-4.35L12.056 0z"/>
                </svg>
                ETH
              </span>
              <span className="text-xs text-green-400 font-semibold flex items-center gap-1.5">
                <svg className="w-3.5 h-3.5" viewBox="0 0 24 24" fill="currentColor">
                  <circle cx="12" cy="12" r="10"/>
                </svg>
                USDT
              </span>
            </div>
          </div>
          <div>
            <h4 className="font-semibold text-sm text-white mb-3">Company</h4>
            <ul className="space-y-2">
              <li>
                <Link href="/about-us" className="text-sm text-slate-400 hover:text-white transition-colors duration-150">
                  About Us
                </Link>
              </li>
              <li>
                <Link href="/careers" className="text-sm text-slate-400 hover:text-white transition-colors duration-150">
                  Careers
                </Link>
              </li>
              <li>
                <Link href="/press" className="text-sm text-slate-400 hover:text-white transition-colors duration-150">
                  Press
                </Link>
              </li>
            </ul>
          </div>
          <div>
            <h4 className="font-semibold text-sm text-white mb-3">Support</h4>
            <ul className="space-y-2">
              <li>
                <Link href="/help-center" className="text-sm text-slate-400 hover:text-white transition-colors duration-150">
                  Help Center
                </Link>
              </li>
              <li>
                <Link href="/cancellation-policy" className="text-sm text-slate-400 hover:text-white transition-colors duration-150">
                  Cancellation Policy
                </Link>
              </li>
              <li>
                <Link href="/baggage-info" className="text-sm text-slate-400 hover:text-white transition-colors duration-150">
                  Baggage Info
                </Link>
              </li>
              <li>
                <Link href="/contact-us" className="text-sm text-slate-400 hover:text-white transition-colors duration-150">
                  Contact Us
                </Link>
              </li>
            </ul>
          </div>
          <div>
            <h4 className="font-semibold text-sm text-white mb-3">Legal</h4>
            <ul className="space-y-2">
              <li>
                <Link href="/legal" className="text-sm text-slate-400 hover:text-white transition-colors duration-150">
                  Legal
                </Link>
              </li>
              <li>
                <Link href="/privacy-policy" className="text-sm text-slate-400 hover:text-white transition-colors duration-150">
                  Privacy Policy
                </Link>
              </li>
              <li>
                <Link href="/terms-of-service" className="text-sm text-slate-400 hover:text-white transition-colors duration-150">
                  Terms of Service
                </Link>
              </li>
              <li>
                <Link href="/cookie-policy" className="text-sm text-slate-400 hover:text-white transition-colors duration-150">
                  Cookie Policy
                </Link>
              </li>
              <li>
                <Link href="/accessibility" className="text-sm text-slate-400 hover:text-white transition-colors duration-150">
                  Accessibility
                </Link>
              </li>
            </ul>
          </div>
        </div>
        <div className="border-t border-slate-700 mt-10 pt-6 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-xs text-slate-500">© 2026 Bitvoyago by TrustLinq CH AG , CHE-329.898.039. All rights reserved. Sennweidstrasse 45, 6312, Steinhausen, Switzerland.</p>
          <p className="text-xs text-slate-500">Prices shown are estimates and may vary at time of booking.</p>
        </div>
      </div>
    </footer>
  );
}